export default __webpack_public_path__ + "static/media/banner-home.bef1cce9.webp";